import React from 'react'
import i18n from '../../../../lib/i18n'
import { isCorrect, orderItemCorrect } from '../../grading'
import Tile, { ItemContent } from './Tile'
import styles from './answers.module.scss'

// type3: tap items in the correct order; tap a placed item to take it back
function AnswerOrder({ question, draft, onChange, checked, order }) {
  const answers = question.answers || []
  const byId = Object.fromEntries(answers.map(_a => [_a._id, _a]))
  const pool = order.filter(id => !draft.includes(id))

  return (
    <div className={styles.stack}>
      <div className={styles.label}>{i18n('qv_your_order')}</div>
      <div className={styles.stack}>
        {answers.map((_a, index) => {
          const id = draft[index]
          if (!id) {
            return (
              <div key={'slot-' + index} className={styles.placeholder}>
                <span className={styles.marker}>{index + 1}</span>
              </div>
            )
          }
          return (
            <Tile
              key={id}
              marker={index + 1}
              state={checked ? (orderItemCorrect(question, draft, index) ? 'correct' : 'wrong') : 'selected'}
              disabled={checked}
              aria-label={i18n('qv_take_back')}
              onClick={() => onChange(draft.filter(_d => _d !== id))}
            >
              <ItemContent item={byId[id]} />
            </Tile>
          )
        })}
      </div>

      {!checked && (
        <>
          <div className={styles.label}>{i18n('qv_items')}</div>
          <div className={styles.pool}>
            {pool.length === 0 && <span className={styles.poolEmpty}>{i18n('qv_all_placed')}</span>}
            {pool.map(id => (
              <Tile key={id} compact onClick={() => onChange([...draft, id])}>
                <ItemContent item={byId[id]} />
              </Tile>
            ))}
          </div>
        </>
      )}

      {checked && !isCorrect(question, draft) && (
        <div className={styles.correctHint}>
          {i18n('qv_correct_order')}:{' '}
          <b>{answers.map((_a, i) => `${i + 1}. ${_a.text || i18n('qv_image')}`).join('  ')}</b>
        </div>
      )}
    </div>
  )
}

export default AnswerOrder
